import Icon from "@ant-design/icons";
import React from "react";

export default function SortDescIcon() {
  return <Icon className="ac-icon" component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        d="M4 6.75C4 6.33579 4.33579 6 4.75 6H11.25C11.6642 6 12 6.33579 12 6.75C12 7.16421 11.6642 7.5 11.25 7.5H4.75C4.33579 7.5 4 7.16421 4 6.75Z"
        fill="#344054"
      />
      <path
        d="M4 11C4 10.5858 4.33579 10.25 4.75 10.25H9.25C9.66421 10.25 10 10.5858 10 11C10 11.4142 9.66421 11.75 9.25 11.75H4.75C4.33579 11.75 4 11.4142 4 11Z"
        fill="#344054"
      />
      <path
        d="M4.75 14.5C4.33579 14.5 4 14.8358 4 15.25C4 15.6642 4.33579 16 4.75 16H8.25C8.66421 16 9 15.6642 9 15.25C9 14.8358 8.66421 14.5 8.25 14.5H4.75Z"
        fill="#344054"
      />
      <path
        d="M16 6C16.2086 6 16.4077 6.08684 16.5496 6.23966L19.7996 9.73966C20.0814 10.0432 20.0639 10.5177 19.7603 10.7996C19.4568 11.0814 18.9823 11.0639 18.7004 10.7603L16.75 8.6599V19.25C16.75 19.6642 16.4142 20 16 20C15.5858 20 15.25 19.6642 15.25 19.25V8.6599L13.2996 10.7603C13.0177 11.0639 12.5432 11.0814 12.2397 10.7996C11.9361 10.5177 11.9186 10.0432 12.2004 9.73966L15.4504 6.23966C15.5923 6.08684 15.7914 6 16 6Z"
        fill="#344054"
      />
    </svg>
  );
};
